@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(268_311_045)
internal val Res.string.error_loading_universes: StringResource by lazy {
      StringResource("string:error_loading_universes", "error_loading_universes", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12775, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11719, 63),
      ))
    }

@delegate:ResourceContentHash(-981_091_181)
internal val Res.string.error_network: StringResource by lazy {
      StringResource("string:error_network", "error_network", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12859, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11783, 81),
      ))
    }

@delegate:ResourceContentHash(297_684_803)
internal val Res.string.error_oauth_failed: StringResource by lazy {
      StringResource("string:error_oauth_failed", "error_oauth_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12945, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11865, 70),
      ))
    }

@delegate:ResourceContentHash(-1_095_794_511)
internal val Res.string.error_opening_table: StringResource by lazy {
      StringResource("string:error_opening_table", "error_opening_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13032, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11936, 63),
      ))
    }

@delegate:ResourceContentHash(-276_894_699)
internal val Res.string.error_otp_invalid: StringResource by lazy {
      StringResource("string:error_otp_invalid", "error_otp_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13104, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12000, 101),
      ))
    }

@delegate:ResourceContentHash(-1_573_903_821)
internal val Res.string.error_otp_rate_limit: StringResource by lazy {
      StringResource("string:error_otp_rate_limit", "error_otp_rate_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13218, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12102, 108),
      ))
    }

@delegate:ResourceContentHash(513_159_734)
internal val Res.string.error_session_expired: StringResource by lazy {
      StringResource("string:error_session_expired", "error_session_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13331, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12211, 93),
      ))
    }

@delegate:ResourceContentHash(1_325_282_547)
internal val Res.string.error_table_not_found: StringResource by lazy {
      StringResource("string:error_table_not_found", "error_table_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13417, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12305, 109),
      ))
    }

@delegate:ResourceContentHash(-725_682_238)
internal val Res.string.error_unexpected: StringResource by lazy {
      StringResource("string:error_unexpected", "error_unexpected", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13527, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12415, 140),
      ))
    }

@delegate:ResourceContentHash(1_756_443_282)
internal val Res.string.error_unknown_auth: StringResource by lazy {
      StringResource("string:error_unknown_auth", "error_unknown_auth", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13692, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12556, 74),
      ))
    }

@delegate:ResourceContentHash(82_707_100)
internal val Res.string.event_author_game_master: StringResource by lazy {
      StringResource("string:event_author_game_master", "event_author_game_master", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13779, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12631, 36),
      ))
    }

@delegate:ResourceContentHash(1_767_570_596)
internal val Res.string.event_author_unknown_player: StringResource by lazy {
      StringResource("string:event_author_unknown_player", "event_author_unknown_player", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13816, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12668, 43),
      ))
    }

@delegate:ResourceContentHash(2_127_769_569)
internal val Res.string.event_combat_started: StringResource by lazy {
      StringResource("string:event_combat_started", "event_combat_started", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13860, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12712, 48),
      ))
    }

@delegate:ResourceContentHash(-237_539_820)
internal val Res.string.event_dice_rolled: StringResource by lazy {
      StringResource("string:event_dice_rolled", "event_dice_rolled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13913, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12761, 41),
      ))
    }

@delegate:ResourceContentHash(1_671_259_889)
internal val Res.string.event_digicode_launched: StringResource by lazy {
      StringResource("string:event_digicode_launched", "event_digicode_launched", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 13955, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12803, 55),
      ))
    }

@delegate:ResourceContentHash(-1_193_592_850)
internal val Res.string.event_format_announcement_all: StringResource by lazy {
      StringResource("string:event_format_announcement_all", "event_format_announcement_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14007, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12859, 73),
      ))
    }

@delegate:ResourceContentHash(-1_345_862_609)
internal val Res.string.event_format_announcement_some: StringResource by lazy {
      StringResource("string:event_format_announcement_some", "event_format_announcement_some", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14081, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12933, 78),
      ))
    }

@delegate:ResourceContentHash(-462_282_759)
internal val Res.string.event_format_item_sent: StringResource by lazy {
      StringResource("string:event_format_item_sent", "event_format_item_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14156, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13012, 62),
      ))
    }

@delegate:ResourceContentHash(610_355_705)
internal val Res.string.event_format_message_sent: StringResource by lazy {
      StringResource("string:event_format_message_sent", "event_format_message_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14227, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13075, 53),
      ))
    }

@delegate:ResourceContentHash(632_161_145)
internal val Res.string.event_format_player_joined: StringResource by lazy {
      StringResource("string:event_format_player_joined", "event_format_player_joined", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14285, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13129, 62),
      ))
    }

@delegate:ResourceContentHash(1_569_019_349)
internal val Res.string.event_format_timer_all: StringResource by lazy {
      StringResource("string:event_format_timer_all", "event_format_timer_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14352, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13192, 70),
      ))
    }

@delegate:ResourceContentHash(2_023_002_978)
internal val Res.string.event_format_timer_some: StringResource by lazy {
      StringResource("string:event_format_timer_some", "event_format_timer_some", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14439, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13263, 75),
      ))
    }

@delegate:ResourceContentHash(-1_405_781_809)
internal val Res.string.event_format_whiteboard_all: StringResource by lazy {
      StringResource("string:event_format_whiteboard_all", "event_format_whiteboard_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14523, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13339, 79),
      ))
    }

@delegate:ResourceContentHash(-424_099_952)
internal val Res.string.event_format_whiteboard_some: StringResource by lazy {
      StringResource("string:event_format_whiteboard_some", "event_format_whiteboard_some", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14615, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13419, 84),
      ))
    }

@delegate:ResourceContentHash(127_637_737)
internal val Res.string.event_lockpicking_launched: StringResource by lazy {
      StringResource("string:event_lockpicking_launched", "event_lockpicking_launched", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14708, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13504, 62),
      ))
    }

@delegate:ResourceContentHash(103_108_830)
internal val Res.string.event_player_joined: StringResource by lazy {
      StringResource("string:event_player_joined", "event_player_joined", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14767, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13567, 63),
      ))
    }

@delegate:ResourceContentHash(-1_435_841_080)
internal val Res.string.event_player_kicked: StringResource by lazy {
      StringResource("string:event_player_kicked", "event_player_kicked", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14835, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13631, 75),
      ))
    }

@delegate:ResourceContentHash(1_135_518_178)
internal val Res.string.event_safety_alert: StringResource by lazy {
      StringResource("string:event_safety_alert", "event_safety_alert", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14915, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13707, 42),
      ))
    }

@delegate:ResourceContentHash(-1_419_131_883)
internal val Res.string.events: StringResource by lazy {
      StringResource("string:events", "events", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15031, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13803, 22),
      ))
    }

@delegate:ResourceContentHash(53_945_309)
internal val Res.string.events_empty: StringResource by lazy {
      StringResource("string:events_empty", "events_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 14970, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13750, 52),
      ))
    }

@delegate:ResourceContentHash(1_822_503_039)
internal val Res.string.expand: StringResource by lazy {
      StringResource("string:expand", "expand", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15062, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13826, 22),
      ))
    }

@delegate:ResourceContentHash(1_820_666_552)
internal val Res.string.feature_character_sheet: StringResource by lazy {
      StringResource("string:feature_character_sheet", "feature_character_sheet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15089, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13849, 67),
      ))
    }

@delegate:ResourceContentHash(2_146_304_517)
internal val Res.string.feature_dice: StringResource by lazy {
      StringResource("string:feature_dice", "feature_dice", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15165, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13917, 36),
      ))
    }

@delegate:ResourceContentHash(-90_296_790)
internal val Res.string.feature_inventory: StringResource by lazy {
      StringResource("string:feature_inventory", "feature_inventory", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15206, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13954, 53),
      ))
    }

@delegate:ResourceContentHash(7_149_952)
internal val Res.string.feature_messages: StringResource by lazy {
      StringResource("string:feature_messages", "feature_messages", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15264, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14008, 36),
      ))
    }

@delegate:ResourceContentHash(1_161_242_656)
internal val Res.string.feature_soundboard: StringResource by lazy {
      StringResource("string:feature_soundboard", "feature_soundboard", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15301, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14045, 42),
      ))
    }

@delegate:ResourceContentHash(148_339_864)
internal val Res.string.feedback_bug_prompt: StringResource by lazy {
      StringResource("string:feedback_bug_prompt", "feedback_bug_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15344, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14088, 131),
      ))
    }

@delegate:ResourceContentHash(1_238_778_471)
internal val Res.string.feedback_bug_title: StringResource by lazy {
      StringResource("string:feedback_bug_title", "feedback_bug_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15484, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14220, 42),
      ))
    }

@delegate:ResourceContentHash(1_401_194_476)
internal val Res.string.feedback_discord_button: StringResource by lazy {
      StringResource("string:feedback_discord_button", "feedback_discord_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15539, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14263, 55),
      ))
    }

@delegate:ResourceContentHash(-2_032_829_075)
internal val Res.string.feedback_header: StringResource by lazy {
      StringResource("string:feedback_header", "feedback_header", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15599, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14319, 131),
      ))
    }

@delegate:ResourceContentHash(1_096_598_959)
internal val Res.string.feedback_message_label: StringResource by lazy {
      StringResource("string:feedback_message_label", "feedback_message_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15755, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14451, 46),
      ))
    }

@delegate:ResourceContentHash(1_238_778_471)
internal val Res.string.feedback_report_bug: StringResource by lazy {
      StringResource("string:feedback_report_bug", "feedback_report_bug", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15806, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14498, 43),
      ))
    }

@delegate:ResourceContentHash(2_084_366_988)
internal val Res.string.feedback_send: StringResource by lazy {
      StringResource("string:feedback_send", "feedback_send", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15862, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14542, 29),
      ))
    }

@delegate:ResourceContentHash(-365_685_661)
internal val Res.string.feedback_suggestion: StringResource by lazy {
      StringResource("string:feedback_suggestion", "feedback_suggestion", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16045, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14713, 51),
      ))
    }

@delegate:ResourceContentHash(-1_314_727_176)
internal val Res.string.feedback_suggestion_prompt: StringResource by lazy {
      StringResource("string:feedback_suggestion_prompt", "feedback_suggestion_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15896, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14572, 82),
      ))
    }

@delegate:ResourceContentHash(-365_685_661)
internal val Res.string.feedback_suggestion_title: StringResource by lazy {
      StringResource("string:feedback_suggestion_title", "feedback_suggestion_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 15983, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14655, 57),
      ))
    }

@delegate:ResourceContentHash(450_834_840)
internal val Res.string.feedback_thank_you: StringResource by lazy {
      StringResource("string:feedback_thank_you", "feedback_thank_you", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16101, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14765, 126),
      ))
    }

@delegate:ResourceContentHash(-556_844_952)
internal val Res.string.field_required: StringResource by lazy {
      StringResource("string:field_required", "field_required", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16216, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14892, 34),
      ))
    }

@delegate:ResourceContentHash(2_044_625_903)
internal val Res.string.game_master: StringResource by lazy {
      StringResource("string:game_master", "game_master", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16247, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14927, 35),
      ))
    }

@delegate:ResourceContentHash(-1_529_138_794)
internal val Res.string.gm_inventory: StringResource by lazy {
      StringResource("string:gm_inventory", "gm_inventory", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16987, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15575, 28),
      ))
    }

@delegate:ResourceContentHash(-930_135_084)
internal val Res.string.gm_inventory_add_item: StringResource by lazy {
      StringResource("string:gm_inventory_add_item", "gm_inventory_add_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16287, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14963, 41),
      ))
    }

@delegate:ResourceContentHash(-674_559_490)
internal val Res.string.gm_inventory_delete_item: StringResource by lazy {
      StringResource("string:gm_inventory_delete_item", "gm_inventory_delete_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16426, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15090, 48),
      ))
    }

@delegate:ResourceContentHash(-1_381_973_457)
internal val Res.string.gm_inventory_delete_item_confirm: StringResource by lazy {
      StringResource("string:gm_inventory_delete_item_confirm", "gm_inventory_delete_item_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16341, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15005, 84),
      ))
    }

@delegate:ResourceContentHash(-1_005_225_676)
internal val Res.string.gm_inventory_edit_item: StringResource by lazy {
      StringResource("string:gm_inventory_edit_item", "gm_inventory_edit_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16483, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15139, 42),
      ))
    }

@delegate:ResourceContentHash(-1_007_631_333)
internal val Res.string.gm_inventory_empty: StringResource by lazy {
      StringResource("string:gm_inventory_empty", "gm_inventory_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16538, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15182, 82),
      ))
    }

@delegate:ResourceContentHash(-1_953_545_038)
internal val Res.string.gm_inventory_error_loading: StringResource by lazy {
      StringResource("string:gm_inventory_error_loading", "gm_inventory_error_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16625, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15265, 62),
      ))
    }

@delegate:ResourceContentHash(-1_430_252_214)
internal val Res.string.gm_inventory_send_all: StringResource by lazy {
      StringResource("string:gm_inventory_send_all", "gm_inventory_send_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16708, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15328, 45),
      ))
    }

@delegate:ResourceContentHash(2_084_366_988)
internal val Res.string.gm_inventory_send_button: StringResource by lazy {
      StringResource("string:gm_inventory_send_button", "gm_inventory_send_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16762, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15374, 40),
      ))
    }

@delegate:ResourceContentHash(1_469_480_576)
internal val Res.string.gm_inventory_send_no_players: StringResource by lazy {
      StringResource("string:gm_inventory_send_no_players", "gm_inventory_send_no_players", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16807, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15415, 68),
      ))
    }

@delegate:ResourceContentHash(-528_750_475)
internal val Res.string.gm_inventory_send_title: StringResource by lazy {
      StringResource("string:gm_inventory_send_title", "gm_inventory_send_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16884, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15484, 51),
      ))
    }

@delegate:ResourceContentHash(627_049_784)
internal val Res.string.gm_inventory_title: StringResource by lazy {
      StringResource("string:gm_inventory_title", "gm_inventory_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 16944, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15536, 38),
      ))
    }

@delegate:ResourceContentHash(-446_934_440)
internal val Res.string.gm_side_panel_close: StringResource by lazy {
      StringResource("string:gm_side_panel_close", "gm_side_panel_close", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17016, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15604, 47),
      ))
    }

@delegate:ResourceContentHash(-156_935_598)
internal val Res.string.gm_side_panel_open: StringResource by lazy {
      StringResource("string:gm_side_panel_open", "gm_side_panel_open", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17072, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15652, 46),
      ))
    }

@delegate:ResourceContentHash(-1_171_541_336)
internal val Res.string.gm_timers: StringResource by lazy {
      StringResource("string:gm_timers", "gm_timers", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17127, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15699, 29),
      ))
    }

@delegate:ResourceContentHash(194_673_738)
internal val Res.string.hide_announcement_text: StringResource by lazy {
      StringResource("string:hide_announcement_text", "hide_announcement_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17161, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15729, 42),
      ))
    }

@delegate:ResourceContentHash(483_676_024)
internal val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17212, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15772, 20),
      ))
    }

@delegate:ResourceContentHash(58_140_155)
internal val Res.string.image_load_error: StringResource by lazy {
      StringResource("string:image_load_error", "image_load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17237, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15793, 64),
      ))
    }

@delegate:ResourceContentHash(-100_680_182)
internal val Res.string.image_optional: StringResource by lazy {
      StringResource("string:image_optional", "image_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17302, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15858, 46),
      ))
    }

@delegate:ResourceContentHash(820_262_288)
internal val Res.string.image_preview: StringResource by lazy {
      StringResource("string:image_preview", "image_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17349, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15905, 41),
      ))
    }

@delegate:ResourceContentHash(1_490_337_184)
internal val Res.string.image_viewer_close: StringResource by lazy {
      StringResource("string:image_viewer_close", "image_viewer_close", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17395, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15947, 34),
      ))
    }

@delegate:ResourceContentHash(461_744_154)
internal val Res.string.inventory: StringResource by lazy {
      StringResource("string:inventory", "inventory", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18934, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17342, 29),
      ))
    }

@delegate:ResourceContentHash(-930_135_084)
internal val Res.string.inventory_add_item: StringResource by lazy {
      StringResource("string:inventory_add_item", "inventory_add_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17430, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15982, 38),
      ))
    }

@delegate:ResourceContentHash(-1_088_313_564)
internal val Res.string.inventory_category_all: StringResource by lazy {
      StringResource("string:inventory_category_all", "inventory_category_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17481, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16021, 34),
      ))
    }

@delegate:ResourceContentHash(978_223_430)
internal val Res.string.inventory_category_clue: StringResource by lazy {
      StringResource("string:inventory_category_clue", "inventory_category_clue", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17520, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16056, 39),
      ))
    }

@delegate:ResourceContentHash(1_558_739_320)
internal val Res.string.inventory_category_consumable: StringResource by lazy {
      StringResource("string:inventory_category_consumable", "inventory_category_consumable", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17564, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16096, 53),
      ))
    }

@delegate:ResourceContentHash(1_630_223_323)
internal val Res.string.inventory_category_equipment: StringResource by lazy {
      StringResource("string:inventory_category_equipment", "inventory_category_equipment", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17618, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16150, 48),
      ))
    }

@delegate:ResourceContentHash(218_303_469)
internal val Res.string.inventory_category_map: StringResource by lazy {
      StringResource("string:inventory_category_map", "inventory_category_map", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17671, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16199, 38),
      ))
    }

@delegate:ResourceContentHash(-303_472_965)
internal val Res.string.inventory_category_other: StringResource by lazy {
      StringResource("string:inventory_category_other", "inventory_category_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17710, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16238, 40),
      ))
    }

@delegate:ResourceContentHash(-347_120_797)
internal val Res.string.inventory_category_weapon: StringResource by lazy {
      StringResource("string:inventory_category_weapon", "inventory_category_weapon", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17751, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16279, 45),
      ))
    }

@delegate:ResourceContentHash(-674_559_490)
internal val Res.string.inventory_delete_item: StringResource by lazy {
      StringResource("string:inventory_delete_item", "inventory_delete_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17928, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16468, 45),
      ))
    }

@delegate:ResourceContentHash(1_759_095_528)
internal val Res.string.inventory_delete_item_cd: StringResource by lazy {
      StringResource("string:inventory_delete_item_cd", "inventory_delete_item_cd", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17793, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16325, 48),
      ))
    }

@delegate:ResourceContentHash(-179_289_030)
internal val Res.string.inventory_delete_item_confirm: StringResource by lazy {
      StringResource("string:inventory_delete_item_confirm", "inventory_delete_item_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17846, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16374, 93),
      ))
    }

@delegate:ResourceContentHash(1_426_653_328)
internal val Res.string.inventory_deselect_all: StringResource by lazy {
      StringResource("string:inventory_deselect_all", "inventory_deselect_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 17982, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16514, 46),
      ))
    }

@delegate:ResourceContentHash(1_041_994_278)
internal val Res.string.inventory_error_loading: StringResource by lazy {
      StringResource("string:inventory_error_loading", "inventory_error_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18041, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16561, 63),
      ))
    }

@delegate:ResourceContentHash(-1_551_498_962)
internal val Res.string.inventory_filter_by_category: StringResource by lazy {
      StringResource("string:inventory_filter_by_category", "inventory_filter_by_category", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18129, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16625, 60),
      ))
    }

@delegate:ResourceContentHash(942_611_742)
internal val Res.string.inventory_give_button: StringResource by lazy {
      StringResource("string:inventory_give_button", "inventory_give_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18198, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16686, 37),
      ))
    }

@delegate:ResourceContentHash(1_007_000_846)
internal val Res.string.inventory_give_item_cd: StringResource by lazy {
      StringResource("string:inventory_give_item_cd", "inventory_give_item_cd", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18236, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16724, 42),
      ))
    }

@delegate:ResourceContentHash(694_985_570)
internal val Res.string.inventory_give_no_recipients: StringResource by lazy {
      StringResource("string:inventory_give_no_recipients", "inventory_give_no_recipients", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18283, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16767, 72),
      ))
    }

@delegate:ResourceContentHash(1_328_300_428)
internal val Res.string.inventory_give_quantity: StringResource by lazy {
      StringResource("string:inventory_give_quantity", "inventory_give_quantity", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18368, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16840, 43),
      ))
    }

@delegate:ResourceContentHash(-666_438_109)
internal val Res.string.inventory_give_title: StringResource by lazy {
      StringResource("string:inventory_give_title", "inventory_give_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18412, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16884, 44),
      ))
    }

@delegate:ResourceContentHash(-1_768_638_851)
internal val Res.string.inventory_item_category: StringResource by lazy {
      StringResource("string:inventory_item_category", "inventory_item_category", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18457, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16929, 43),
      ))
    }

@delegate:ResourceContentHash(1_762_742_557)
internal val Res.string.inventory_item_image_optional: StringResource by lazy {
      StringResource("string:inventory_item_image_optional", "inventory_item_image_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18505, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16973, 61),
      ))
    }

@delegate:ResourceContentHash(-1_933_983_174)
internal val Res.string.inventory_item_name: StringResource by lazy {
      StringResource("string:inventory_item_name", "inventory_item_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18636, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17088, 39),
      ))
    }

@delegate:ResourceContentHash(-893_832_435)
internal val Res.string.inventory_item_name_hint: StringResource by lazy {
      StringResource("string:inventory_item_name_hint", "inventory_item_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18571, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17035, 52),
      ))
    }

@delegate:ResourceContentHash(1_328_300_428)
internal val Res.string.inventory_item_quantity: StringResource by lazy {
      StringResource("string:inventory_item_quantity", "inventory_item_quantity", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18684, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17128, 43),
      ))
    }

@delegate:ResourceContentHash(1_939_537_815)
internal val Res.string.inventory_no_items: StringResource by lazy {
      StringResource("string:inventory_no_items", "inventory_no_items", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18728, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17172, 74),
      ))
    }

@delegate:ResourceContentHash(-404_062_986)
internal val Res.string.inventory_search_hint: StringResource by lazy {
      StringResource("string:inventory_search_hint", "inventory_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18831, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17247, 49),
      ))
    }

@delegate:ResourceContentHash(-1_078_983_202)
internal val Res.string.inventory_select_all: StringResource by lazy {
      StringResource("string:inventory_select_all", "inventory_select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18881, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17297, 44),
      ))
    }

@delegate:ResourceContentHash(66_084_903)
internal val Res.string.item_sender_game_master: StringResource by lazy {
      StringResource("string:item_sender_game_master", "item_sender_game_master", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 18968, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17372, 39),
      ))
    }

@delegate:ResourceContentHash(387_207_738)
internal val Res.string.join: StringResource by lazy {
      StringResource("string:join", "join", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19055, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17447, 20),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("error_loading_universes", Res.string.error_loading_universes)
  map.put("error_network", Res.string.error_network)
  map.put("error_oauth_failed", Res.string.error_oauth_failed)
  map.put("error_opening_table", Res.string.error_opening_table)
  map.put("error_otp_invalid", Res.string.error_otp_invalid)
  map.put("error_otp_rate_limit", Res.string.error_otp_rate_limit)
  map.put("error_session_expired", Res.string.error_session_expired)
  map.put("error_table_not_found", Res.string.error_table_not_found)
  map.put("error_unexpected", Res.string.error_unexpected)
  map.put("error_unknown_auth", Res.string.error_unknown_auth)
  map.put("event_author_game_master", Res.string.event_author_game_master)
  map.put("event_author_unknown_player", Res.string.event_author_unknown_player)
  map.put("event_combat_started", Res.string.event_combat_started)
  map.put("event_dice_rolled", Res.string.event_dice_rolled)
  map.put("event_digicode_launched", Res.string.event_digicode_launched)
  map.put("event_format_announcement_all", Res.string.event_format_announcement_all)
  map.put("event_format_announcement_some", Res.string.event_format_announcement_some)
  map.put("event_format_item_sent", Res.string.event_format_item_sent)
  map.put("event_format_message_sent", Res.string.event_format_message_sent)
  map.put("event_format_player_joined", Res.string.event_format_player_joined)
  map.put("event_format_timer_all", Res.string.event_format_timer_all)
  map.put("event_format_timer_some", Res.string.event_format_timer_some)
  map.put("event_format_whiteboard_all", Res.string.event_format_whiteboard_all)
  map.put("event_format_whiteboard_some", Res.string.event_format_whiteboard_some)
  map.put("event_lockpicking_launched", Res.string.event_lockpicking_launched)
  map.put("event_player_joined", Res.string.event_player_joined)
  map.put("event_player_kicked", Res.string.event_player_kicked)
  map.put("event_safety_alert", Res.string.event_safety_alert)
  map.put("events", Res.string.events)
  map.put("events_empty", Res.string.events_empty)
  map.put("expand", Res.string.expand)
  map.put("feature_character_sheet", Res.string.feature_character_sheet)
  map.put("feature_dice", Res.string.feature_dice)
  map.put("feature_inventory", Res.string.feature_inventory)
  map.put("feature_messages", Res.string.feature_messages)
  map.put("feature_soundboard", Res.string.feature_soundboard)
  map.put("feedback_bug_prompt", Res.string.feedback_bug_prompt)
  map.put("feedback_bug_title", Res.string.feedback_bug_title)
  map.put("feedback_discord_button", Res.string.feedback_discord_button)
  map.put("feedback_header", Res.string.feedback_header)
  map.put("feedback_message_label", Res.string.feedback_message_label)
  map.put("feedback_report_bug", Res.string.feedback_report_bug)
  map.put("feedback_send", Res.string.feedback_send)
  map.put("feedback_suggestion", Res.string.feedback_suggestion)
  map.put("feedback_suggestion_prompt", Res.string.feedback_suggestion_prompt)
  map.put("feedback_suggestion_title", Res.string.feedback_suggestion_title)
  map.put("feedback_thank_you", Res.string.feedback_thank_you)
  map.put("field_required", Res.string.field_required)
  map.put("game_master", Res.string.game_master)
  map.put("gm_inventory", Res.string.gm_inventory)
  map.put("gm_inventory_add_item", Res.string.gm_inventory_add_item)
  map.put("gm_inventory_delete_item", Res.string.gm_inventory_delete_item)
  map.put("gm_inventory_delete_item_confirm", Res.string.gm_inventory_delete_item_confirm)
  map.put("gm_inventory_edit_item", Res.string.gm_inventory_edit_item)
  map.put("gm_inventory_empty", Res.string.gm_inventory_empty)
  map.put("gm_inventory_error_loading", Res.string.gm_inventory_error_loading)
  map.put("gm_inventory_send_all", Res.string.gm_inventory_send_all)
  map.put("gm_inventory_send_button", Res.string.gm_inventory_send_button)
  map.put("gm_inventory_send_no_players", Res.string.gm_inventory_send_no_players)
  map.put("gm_inventory_send_title", Res.string.gm_inventory_send_title)
  map.put("gm_inventory_title", Res.string.gm_inventory_title)
  map.put("gm_side_panel_close", Res.string.gm_side_panel_close)
  map.put("gm_side_panel_open", Res.string.gm_side_panel_open)
  map.put("gm_timers", Res.string.gm_timers)
  map.put("hide_announcement_text", Res.string.hide_announcement_text)
  map.put("home", Res.string.home)
  map.put("image_load_error", Res.string.image_load_error)
  map.put("image_optional", Res.string.image_optional)
  map.put("image_preview", Res.string.image_preview)
  map.put("image_viewer_close", Res.string.image_viewer_close)
  map.put("inventory", Res.string.inventory)
  map.put("inventory_add_item", Res.string.inventory_add_item)
  map.put("inventory_category_all", Res.string.inventory_category_all)
  map.put("inventory_category_clue", Res.string.inventory_category_clue)
  map.put("inventory_category_consumable", Res.string.inventory_category_consumable)
  map.put("inventory_category_equipment", Res.string.inventory_category_equipment)
  map.put("inventory_category_map", Res.string.inventory_category_map)
  map.put("inventory_category_other", Res.string.inventory_category_other)
  map.put("inventory_category_weapon", Res.string.inventory_category_weapon)
  map.put("inventory_delete_item", Res.string.inventory_delete_item)
  map.put("inventory_delete_item_cd", Res.string.inventory_delete_item_cd)
  map.put("inventory_delete_item_confirm", Res.string.inventory_delete_item_confirm)
  map.put("inventory_deselect_all", Res.string.inventory_deselect_all)
  map.put("inventory_error_loading", Res.string.inventory_error_loading)
  map.put("inventory_filter_by_category", Res.string.inventory_filter_by_category)
  map.put("inventory_give_button", Res.string.inventory_give_button)
  map.put("inventory_give_item_cd", Res.string.inventory_give_item_cd)
  map.put("inventory_give_no_recipients", Res.string.inventory_give_no_recipients)
  map.put("inventory_give_quantity", Res.string.inventory_give_quantity)
  map.put("inventory_give_title", Res.string.inventory_give_title)
  map.put("inventory_item_category", Res.string.inventory_item_category)
  map.put("inventory_item_image_optional", Res.string.inventory_item_image_optional)
  map.put("inventory_item_name", Res.string.inventory_item_name)
  map.put("inventory_item_name_hint", Res.string.inventory_item_name_hint)
  map.put("inventory_item_quantity", Res.string.inventory_item_quantity)
  map.put("inventory_no_items", Res.string.inventory_no_items)
  map.put("inventory_search_hint", Res.string.inventory_search_hint)
  map.put("inventory_select_all", Res.string.inventory_select_all)
  map.put("item_sender_game_master", Res.string.item_sender_game_master)
  map.put("join", Res.string.join)
}
